export const FETCH_ALL_SPECIALISTS = 'FETCH_SPECIALISTS';
export const REGISTER_SPECIALIST = 'REGISTER_SPECIALIST';
export const DEREGISTER_SPECIALIST = 'DEREGISTER_SPECIALIST';